import { FormInstance } from 'antd';
import { useHasValidDisputeFiles } from '@pay-bill/hooks';

export const useHasValidErrorDisputeFields = (
  form: FormInstance,
  formValues: Record<string, unknown>
) => {
  const hasValidFiles = useHasValidDisputeFiles(form);

  const allFieldsFilledIn = !!(
    (!!formValues.newHours || formValues.newHours === 0) &&
    formValues.newPayCode &&
    formValues.comment
  );

  return hasValidFiles && allFieldsFilledIn;
};
